import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.containers = []
    const inputs = this.element.querySelectorAll(".js-search-form")
    inputs.forEach(input => this.setupAutocomplete(input))
  }

  disconnect() {
    this.containers.forEach(container => container.remove())
    this.containers = []
  }

  setupAutocomplete(input) {
    const wrapper = input.parentElement
    wrapper.style.position = 'relative'

    const dropdown = document.createElement('div')
    dropdown.className = 'autocomplete-results'
    dropdown.style.cssText = 'position:absolute;top:100%;left:0;right:0;z-index:1100;background:#fff;border:1px solid #ccc;display:none;max-height:200px;overflow-y:auto;'
    wrapper.appendChild(dropdown)
    this.containers.push(dropdown)

    // Ensure parent card does not clip the dropdown
    const card = input.closest('.card')
    if (card) {
      card.style.overflow = 'visible'
      card.style.position = 'relative'
      card.style.zIndex = '10'
    }

    let debounceTimer
    let abortController
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer)
      if (abortController) abortController.abort()
      const query = input.value.trim()
      if (query.length < 3) {
        dropdown.style.display = 'none'
        return
      }
      debounceTimer = setTimeout(() => {
        abortController = new AbortController()
        const timeoutId = setTimeout(() => abortController.abort(), 5000)
        fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(query)}&limit=5`, { signal: abortController.signal })
          .then(res => {
            clearTimeout(timeoutId)
            if (!res.ok) throw new Error('Network error')
            return res.json()
          })
          .then(data => {
            dropdown.innerHTML = ''
            if (data.features && data.features.length > 0) {
              data.features.forEach(feature => {
                const item = document.createElement('div')
                item.textContent = feature.properties.label
                item.style.cssText = 'padding:8px 12px;cursor:pointer;border-bottom:1px solid #eee;'
                item.addEventListener('mousedown', (e) => {
                  e.preventDefault()
                  input.value = feature.properties.label
                  dropdown.style.display = 'none'
                  const form = input.closest('form')
                  if (form) form.submit()
                })
                dropdown.appendChild(item)
              })
              dropdown.style.display = 'block'
            } else {
              dropdown.style.display = 'none'
            }
          })
          .catch(() => {
            dropdown.style.display = 'none'
          })
      }, 300)
    })

    input.addEventListener('blur', () => {
      setTimeout(() => { dropdown.style.display = 'none' }, 200)
    })
  }
}
